
  import { createRoot } from "react-dom/client";
  import App from "./App.tsx";
  import "./index.css";

  (function () {
    try {
      var path = window.location.pathname;
      if (path === "/profile") {
        var u = new URL(window.location.href);
        u.pathname = "/settings";
        u.search = "";
        window.history.replaceState(null, "", u.toString());
      }
      var search = window.location.search;
      if (search) {
        var params = new URLSearchParams(search);
        var tool = params.get("tool");
        if (tool && ["dstudio", "halftone", "ascii", "raster"].indexOf(tool) !== -1) {
          var url = new URL(window.location.href);
          url.search = "";
          url.pathname = tool === "raster" ? "/raster/" : "/" + tool;
          window.history.replaceState(null, "", url.toString());
        }
      }
    } catch (e) {}
  })();

  (function () {
    try {
      var handler = function (e) {
        var msg = "";
        try { msg = String((e && (e.message || (e.error && e.error.message))) || ""); } catch {}
        if (msg && msg.indexOf("Failed to execute 'removeChild'") !== -1) {
          try { e.preventDefault && e.preventDefault(); } catch {}
          return true;
        }
      };
      window.addEventListener("error", handler, true);
      window.addEventListener("unhandledrejection", function (e) {
        var reason = "";
        try { reason = String((e && (e.reason && (e.reason.message || e.reason))) || ""); } catch {}
        if (reason && reason.indexOf("Failed to execute 'removeChild'") !== -1) {
          try { e.preventDefault && e.preventDefault(); } catch {}
        }
      });
    } catch {}
  })();

  createRoot(document.getElementById("root")!).render(<App />);
  
